import { CustomSelect } from '../../vendors/custom-slect'
import { validEmail } from '../../common/validate'

const smallForm = () => {
  const formSelectElements = document.querySelectorAll('.small-form-select-grade')
  for (const element of formSelectElements) {
    const selectGrade = new CustomSelect(element)
  }

  const btn = document.querySelectorAll('.submit-small-form')
  for (let i = 0; i < btn.length; i++) {
    btn[i].addEventListener('click', function (e) {
      e.preventDefault()
      const parent = this.parentElement
      const formEmailBox = parent.querySelector('.small-form-box__field.email .field-border')
      const formMessage = parent.querySelector('.small-form-box__field.email .message-success')
      const formEmail = parent.querySelector('.email-small-form').value
      const formSelectButton = parent.querySelector('.select__toggle')
      const formSmallGrade = formSelectButton.value
      const formSelectElement = parent.querySelector('.small-form-select-grade .field-border')
      const isValidEmail = validEmail(formEmail)

      if (formSmallGrade) {
        formSelectElement.classList.remove('error')
        formSelectElement.classList.add('valid')
      } else {
        formSelectElement.classList.remove('valid')
        formSelectElement.classList.add('error')
      }

      if (isValidEmail) {
        formEmailBox.classList.remove('error')
        formEmailBox.classList.add('valid')
      } else {
        formEmailBox.classList.remove('valid')
        formEmailBox.classList.add('error')
      }

      if (formSmallGrade && isValidEmail) {
        // validation
        formMessage.classList.add('active')
        btn[i].setAttribute('disabled', 'disabled')

        const appUrl = parent.querySelector('.small-form-box__url').value
        let params = new URLSearchParams(window.location.search).toString()
        params = params.length > 0 ? '&' + params : ''
        window.location.href = `${appUrl}?email=${formEmail}&grade=${formSmallGrade}` + params
      }
    })
  }
}
export default smallForm
